import FormLayout, { LayoutSchemaField } from "@mapmycustomers/shared/types/layout/FormLayout";

import getChildLayout, { Variant } from "./getChildLayout";

const getActualLayoutSchema = (layout: FormLayout, variant?: Variant): LayoutSchemaField[] =>
  getChildLayout(layout, variant)?.schema ?? layout.schema;

export default getActualLayoutSchema;
